import { useState } from 'react';
import { Alert, Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconCheck, IconServer, IconX } from '@tabler/icons-react';
import { checkApiUrl, getApiBase, setApiBase } from '../api/client';

/**
 * Адрес сервера для приложения на планшете.
 *
 * Адрес проверяется до сохранения: узнать, что он введён с ошибкой, замерщик
 * должен здесь, а не на объекте, когда наряды не загрузились.
 */
export function ServerSettingsModal({
  opened,
  onClose,
  onSaved,
}: {
  opened: boolean;
  onClose: () => void;
  onSaved?: () => void;
}) {
  const [url, setUrl] = useState(() => {
    const current = getApiBase();
    return current === '/api' ? 'https://' : current;
  });
  const [checking, setChecking] = useState(false);
  const [result, setResult] = useState<{ ok: boolean; error?: string } | null>(null);

  const save = async () => {
    setChecking(true);
    setResult(null);
    const check = await checkApiUrl(url);
    setResult(check);
    setChecking(false);

    if (check.ok) {
      setApiBase(url);
      onSaved?.();
      onClose();
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Подключение к серверу" size="md">
      <Stack>
        <Text size="sm" c="dimmed">
          Укажите адрес сервера CRM. Спросите его у руководителя — он один на всю
          компанию и меняется редко.
        </Text>

        <TextInput
          label="Адрес сервера"
          placeholder="https://crm.вашдомен.ru/api"
          value={url}
          onChange={(e) => setUrl(e.currentTarget.value)}
          leftSection={<IconServer size={18} />}
          description="Полный адрес вместе с /api на конце"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
        />

        {result && (
          <Alert
            color={result.ok ? 'teal' : 'red'}
            icon={result.ok ? <IconCheck size={18} /> : <IconX size={18} />}
          >
            {result.ok ? 'Сервер отвечает, адрес сохранён' : result.error}
          </Alert>
        )}

        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose}>
            Отмена
          </Button>
          <Button onClick={() => void save()} loading={checking}>
            Проверить и сохранить
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
